var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 590,
    height: 400,
    viewBox: "0 0 590 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_236)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 478.487,
    cy: 4.29015,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 478.487,
    cy: 27.2941,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 478.487,
    cy: 50.298,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 478.487,
    cy: 73.3019,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 478.487,
    cy: 96.3053,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 478.487,
    cy: 119.309,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.951,
    cy: 4.29015,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.951,
    cy: 27.2941,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.951,
    cy: 50.298,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.951,
    cy: 73.3019,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.951,
    cy: 96.3053,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.951,
    cy: 119.309,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.414,
    cy: 4.29015,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.414,
    cy: 27.2941,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.414,
    cy: 50.298,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.414,
    cy: 73.3019,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.414,
    cy: 96.3053,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.414,
    cy: 119.309,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 551.877,
    cy: 4.29015,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 551.877,
    cy: 27.2941,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 551.877,
    cy: 50.298,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 551.877,
    cy: 73.3019,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 551.877,
    cy: 96.3053,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 551.877,
    cy: 119.309,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.341,
    cy: 4.29015,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.341,
    cy: 27.2941,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.341,
    cy: 50.298,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.341,
    cy: 73.3019,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.341,
    cy: 96.3053,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.341,
    cy: 119.309,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.36514,
    cy: 297.589,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.36514,
    cy: 320.593,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.36514,
    cy: 343.597,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.36514,
    cy: 366.601,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.36514,
    cy: 389.605,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8285,
    cy: 297.589,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8285,
    cy: 320.593,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8285,
    cy: 343.597,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8285,
    cy: 366.601,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8285,
    cy: 389.605,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2919,
    cy: 297.589,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2919,
    cy: 320.593,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2919,
    cy: 343.597,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2919,
    cy: 366.601,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2919,
    cy: 389.605,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2785 375.683C42.2785 375.683 -30.0321 291.926 30.0499 201.248C83.3588 120.792 145.511 126.292 191.112 158.942C210.534 172.849 266.53 160.655 314.188 78.7892C379.183 -32.8564 604.476 34.8558 563.398 206.625C543.52 289.748 623.898 292.77 582.942 375.861L42.2785 375.683Z",
    fill: "#EBF3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.184 262.327L52.9229 313.188L103.783 368.449L159.045 317.589L108.184 262.327Z",
    fill: "#DFEBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.184 262.327L52.9224 313.188L63.1653 324.317L118.427 273.456L108.184 262.327Z",
    fill: "#BED7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.571 44.638L307.464 50.0431L282.318 32.9023L281.04 38.3977L271.824 40.0659L269.571 44.638Z",
    fill: "#9EC3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.464 50.0427L275.932 33.7835L245.026 32.231L307.464 50.0427Z",
    fill: "#CDE0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.318 32.9022L307.464 50.0429L287.998 23.2559L282.318 32.9022Z",
    fill: "#CDE0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.463 119.391L471.932 126.23L462.351 119.465C464.475 116.477 467.98 114.501 471.932 114.501C475.859 114.501 479.341 116.429 481.463 119.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.932 97.835C462.351 97.835 453.882 102.601 448.746 109.885L454.796 114.131C458.598 108.749 464.871 105.241 471.932 105.241C478.945 105.241 485.167 108.698 488.969 114.006L494.994 109.684C489.834 102.502 481.414 97.835 471.932 97.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.932 66.1543C451.661 66.1543 433.733 76.2286 422.87 91.6363L428.921 95.8822C438.451 82.3996 454.181 73.5608 471.935 73.5608C489.54 73.5608 505.17 82.2515 514.726 95.5606L520.726 91.2384C509.835 76.0574 492.032 66.1543 471.932 66.1543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.932 83.4893C457.513 83.4893 444.722 90.6251 436.943 101.565L442.991 105.811C449.435 96.7983 460.005 90.8958 471.93 90.8958C483.758 90.8958 494.251 96.6988 500.721 105.588L506.721 101.292C498.921 90.5024 486.229 83.4893 471.932 83.4893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.231 160.893L265.494 160.692C268.301 164.332 268.932 167.682 267.183 170.519C265.436 173.413 261.253 175.79 255.008 177.594C259.735 165.016 262.113 151.751 262.113 138.144C262.113 108.712 250.662 79.9051 229.051 58.3542C208.132 37.4373 179.855 25.2944 149.262 25.2944C132.082 25.2944 115.482 29.103 100.385 36.3822C100.38 36.3845 100.376 36.3869 100.371 36.3892C95.5166 34.9083 90.7895 33.6936 86.2289 32.7704C63.2042 28.0988 46.864 31.3265 40.2257 41.8637C33.909 51.8848 37.3473 66.9685 49.8812 84.5628C49.8789 84.5651 49.8789 84.5674 49.8766 84.572C47.0769 89.7457 44.3813 95.8843 42.3983 101.761C18.8483 103.164 6.24269 107.308 1.65902 114.814C-3.66969 123.553 3.60726 135.279 26.9004 146.682C30.1097 148.257 33.548 149.805 37.1576 151.351C39.948 175.868 51.1168 199.633 69.4445 217.961C79.815 228.304 91.8769 236.439 105.313 242.14C146.476 259.503 195.545 251.375 229.051 217.961C239.135 207.878 247.129 196.13 252.773 183.124C264.261 180.746 271.825 177.023 274.833 172.094C276.924 168.684 276.667 164.903 274.231 160.893ZM247.273 179.371C239.623 180.746 230.083 181.549 218.938 181.664C201.644 181.875 181.783 180.51 160.852 177.752C162.613 173.918 164.339 169.977 166.023 165.949C172.518 168.122 178.821 169.843 184.832 171.062C191.718 172.46 198.005 173.149 203.613 173.149C216.763 173.149 226.182 169.353 230.835 161.967C231.601 160.75 232.226 159.461 232.707 158.098H226.004C225.893 158.302 225.775 158.503 225.652 158.7C222.196 164.186 214.474 167.02 203.63 167.018C198.444 167.018 192.539 166.37 186.049 165.053C180.394 163.906 174.462 162.295 168.346 160.264C169.961 156.226 171.53 152.11 173.046 147.934C177.132 136.668 180.63 125.501 183.458 114.777C206.388 118.157 230.345 118.259 253.358 116.523C254.813 123.583 255.549 130.809 255.549 138.146C255.551 152.441 252.773 166.308 247.273 179.371ZM107.625 235.317C104.365 234.135 102.71 229.456 101.896 225.738C100.609 219.863 100.376 211.612 101.222 201.878C101.65 196.954 102.338 191.72 103.266 186.243C116.628 189.804 129.861 194.383 142.746 199.904C139.845 204.909 136.908 209.548 133.974 213.755C128.384 221.77 122.917 227.952 118.162 231.636C115.154 233.97 110.885 236.499 107.625 235.317ZM145.696 194.668C132.209 188.856 118.342 184.052 104.339 180.345C104.832 177.805 105.373 175.218 105.961 172.592C109.855 173.478 113.805 174.334 117.803 175.16C129.507 177.553 141.18 179.587 152.608 181.229C150.347 185.912 148.036 190.401 145.696 194.668ZM120.383 170.919C115.862 169.989 111.406 169.017 107.025 168.008C109.087 159.429 111.621 150.486 114.575 141.374C129.944 150.821 145.576 158.508 160.373 163.961C158.517 168.395 156.608 172.717 154.662 176.898C143.424 175.285 131.922 173.286 120.383 170.919ZM82.8461 55.1218C91.3887 72.6235 107.854 87.0455 125.571 96.6108C121.279 105.963 117.19 115.945 113.43 126.311C112.729 128.243 112.049 130.173 111.382 132.098C88.9291 117.484 69.9212 100.713 57.4497 84.4818C57.4474 84.4795 57.4474 84.4772 57.4451 84.4749C64.0256 73.2482 72.6006 63.3359 82.8461 55.1218ZM178.853 38.9274C182.113 40.1098 183.768 44.7883 184.582 48.5066C185.869 54.3814 186.102 62.6325 185.256 72.3667C184.328 83.0218 182.194 95.1253 179.02 108.013C163.406 105.327 147.802 100.898 133.435 93.9245C139.558 81.1545 146.032 69.7683 152.506 60.4875C158.096 52.4725 163.564 46.29 168.318 42.6064C170.799 40.6836 174.135 38.6266 177.058 38.6266C177.678 38.6266 178.279 38.7192 178.853 38.9274ZM177.532 113.819C174.776 124.189 171.382 134.99 167.425 145.895C165.9 150.099 164.322 154.236 162.698 158.292C147.841 152.836 132.07 145.034 116.568 135.397C117.368 133.056 118.197 130.705 119.05 128.349C122.725 118.217 126.714 108.467 130.895 99.3342C145.527 106.426 161.379 111.005 177.532 113.819ZM224.41 62.968C238.196 76.7537 247.342 93.3136 251.967 110.628C227.464 112.419 205.011 111.857 184.941 108.953C188.127 95.9398 190.27 83.6974 191.211 72.885C192.25 60.9434 192.123 46.8013 187.282 38.8418C201.306 44.2284 213.833 52.3614 224.41 62.968ZM149.262 31.8263C156.627 31.8263 163.869 32.5668 170.949 34.0383C162.599 37.6733 154.072 47.7917 147.601 57.0677C140.976 66.5636 134.363 78.1836 128.116 91.1895C111.255 82.0292 95.3315 67.9843 87.719 51.4405C105.491 38.7979 126.866 31.8263 149.262 31.8263ZM45.4086 45.1284C48.8655 39.6424 56.5866 36.8103 67.4315 36.8103C72.6191 36.8103 78.5216 37.4582 85.0119 38.7747C87.4761 39.2745 89.9912 39.8599 92.5503 40.5355C92.5526 40.5355 92.5549 40.5355 92.5572 40.5378C77.0755 49.4923 63.4379 62.4497 53.2848 78.695C53.2825 78.6973 53.2802 78.6996 53.2802 78.7042C43.6987 64.4766 40.818 52.4123 45.4086 45.1284ZM54.259 90.3566C54.259 90.3543 54.2613 90.3519 54.2613 90.3519C67.3922 106.764 86.7449 123.541 109.36 138.093C106.153 147.853 103.418 157.443 101.211 166.634C82.462 162.099 60.6705 155.682 43.4604 148.401C42.0328 134.129 43.5876 119.684 47.8728 106.056C49.5341 100.773 51.7415 95.3266 54.259 90.3566ZM32.1134 143.301C11.8005 133.389 2.51745 123.819 6.67306 117.03C10.0258 111.53 22.2288 107.805 40.9106 106.431C37.146 119.14 35.8341 132.355 36.6138 145.423C35.0636 144.734 33.5735 144.019 32.1134 143.301ZM100.142 171.236C99.5634 173.82 99.0289 176.368 98.5384 178.874C97.2357 178.557 95.9307 178.249 94.6258 177.951C72.5751 172.932 56.029 171.912 48.3587 171.738C46.4591 166.016 45.0615 160.162 44.1777 154.188C59.1966 159.968 76.1083 165.509 100.142 171.236ZM50.5777 177.805C58.757 178.133 73.9241 179.374 93.2976 183.781C94.6836 184.096 96.0696 184.427 97.4532 184.765C96.456 190.579 95.7202 196.137 95.2667 201.359C94.4059 211.256 94.3458 222.665 97.1062 230.814C88.7047 226.085 80.9997 220.233 74.086 213.32C63.778 203.014 55.8485 190.947 50.5777 177.805ZM117.026 239.489C124.89 235.368 132.792 225.9 138.877 217.177C142.015 212.679 145.153 207.699 148.248 202.324C166.102 210.409 183.268 220.342 199.393 231.913C172.812 246.118 142.88 247.726 117.026 239.489ZM224.41 213.322C218.533 219.215 212.063 224.336 205.073 228.649C188.134 216.27 170.038 205.672 151.182 197.095C153.774 192.345 156.328 187.329 158.823 182.092C176.081 184.381 192.674 185.753 207.82 186.107C211.774 186.22 215.613 186.22 219.338 186.192C228.994 186.079 237.587 185.505 244.952 184.473C239.794 195.158 232.89 204.842 224.41 213.322Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.999 178.503L206.392 364.066C206.392 364.066 204.756 375.314 213.123 375.335C226.881 375.367 281.596 375.335 281.596 375.335C281.596 375.335 271.241 372.993 271.366 367.725C271.514 361.514 289.606 176.747 289.606 176.747L221.999 178.503Z",
    fill: "#D86713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.036 371.969C283.331 371.976 231.069 372.14 217.672 371.969C211.834 371.897 210.809 366.776 210.761 363.465C210.738 361.878 210.939 360.703 210.939 360.703L211.344 355.881L212.378 343.587L213.292 332.726L214.465 318.769L215.453 306.99L226.541 175.135L294.153 173.381C294.153 173.381 286.533 250.704 281.142 306.99C280.541 313.26 279.969 319.274 279.439 324.887C279.268 326.68 279.104 328.432 278.942 330.137C278.442 335.464 277.986 340.353 277.588 344.67C277.378 346.947 277.186 349.06 277.01 350.998C276.323 358.588 275.92 363.435 275.913 364.358C275.911 364.895 275.957 365.395 276.045 365.86C277.158 371.777 285.02 371.969 286.036 371.969Z",
    fill: "#F99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8037 77.5288L95.8174 230.224L101.021 251.137L118.726 322.256H447.661L382.402 77.5288H57.8037Z",
    fill: "#F99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8013 77.5288L52.5327 79.285L111.722 327.569L118.726 322.256L57.8013 77.5288Z",
    fill: "#EE9849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.723 327.569H438.632L447.658 322.256H118.727L111.723 327.569Z",
    fill: "#D86713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.523 375.407H297.303V372.042H226.523V375.407Z",
    fill: "#F1A34F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.725 277.162L378.35 80.7635H57.2759V77.5288H382.401L435.596 276.725L431.725 277.162Z",
    fill: "#F1A34F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.312 327.566L278.946 330.139L212.38 343.587L213.294 332.726L213.729 327.566H279.312Z",
    fill: "#D86713"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M286.036 371.968C283.331 371.975 231.069 372.139 217.672 371.968C211.834 371.897 210.809 366.776 210.761 363.465L277.012 351C276.325 358.59 275.922 363.437 275.915 364.36C275.913 364.897 275.959 365.397 276.047 365.862C277.158 371.776 285.02 371.968 286.036 371.968Z",
    fill: "#D86713"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M263.222 272.715L118.726 322.256L101.021 251.137L263.222 272.715Z",
    fill: "#D86713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8013 77.5288H382.402L435.069 274.212H105.096L57.8013 77.5288Z",
    fill: "#699DEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.913 299.076C290.976 294.252 286.305 290.342 281.483 290.342C276.658 290.342 273.509 294.252 274.446 299.076C275.383 303.901 280.055 307.811 284.877 307.811C289.701 307.811 292.85 303.901 291.913 299.076Z",
    fill: "#D86713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.76 265.69H115.836L81.4159 128.576L78.7805 118.062L76.5268 109.094L74.7267 101.914L71.249 88.0635H370.791L371.001 88.8247L374.606 101.914L376.587 109.094L379.06 118.062L381.96 128.576L419.76 265.69Z",
    fill: "#E9F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.76 266.158H115.836L81.4159 129.046L78.7805 118.532L76.5268 109.563L74.7267 102.381L71.249 88.5332H370.791L371.001 89.2944L374.606 102.381L376.587 109.563L379.06 118.532L381.96 129.046L419.76 266.158Z",
    fill: "#E9F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.606 101.914H74.7267L71.249 88.0635H370.677L371.001 88.8247L374.606 101.914Z",
    fill: "#AFCDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5813 94.9888C79.2204 93.5381 80.1019 92.3604 81.555 92.3604C83.0081 92.3604 84.4774 93.5381 84.8383 94.9888C85.1993 96.4396 84.3177 97.6173 82.8646 97.6173C81.4115 97.6173 79.9423 96.4396 79.5813 94.9888Z",
    fill: "#E9F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1774 96.9665C94.0259 96.0058 93.7145 94.3445 92.4818 93.2557C91.2492 92.167 89.5621 92.0631 88.7136 93.0238C87.8651 93.9844 88.1765 95.6458 89.4092 96.7345C90.6418 97.8233 92.3289 97.9271 93.1774 96.9665Z",
    fill: "#E9F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7215 94.9888C97.3605 93.5381 98.2421 92.3604 99.6951 92.3604C101.148 92.3604 102.617 93.5381 102.978 94.9888C103.339 96.4396 102.458 97.6173 101.005 97.6173C99.5517 97.6173 98.0847 96.4396 97.7215 94.9888Z",
    fill: "#E9F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.511 266.158H180.459C180.169 263.81 179.917 261.327 179.688 258.738C179.286 254.092 178.976 249.096 178.749 243.897C178.693 242.698 178.647 241.488 178.603 240.271C178.545 238.721 178.497 237.152 178.45 235.576C178.376 232.899 178.318 230.192 178.277 227.469C178.274 227.466 178.274 227.462 178.274 227.46C178.221 223.986 178.196 220.49 178.189 217.008C178.189 217.006 178.189 217.006 178.189 217.006C178.187 216.136 178.187 215.268 178.187 214.4V214.398C178.187 213.581 178.189 212.769 178.191 211.957C178.217 204.46 178.33 197.107 178.49 190.27C178.834 175.142 179.397 162.536 179.695 156.476V156.474C179.815 153.987 179.894 152.603 179.894 152.603C179.896 152.603 179.899 152.605 179.901 152.605C179.968 152.615 180.424 152.7 181.141 152.871C181.667 152.999 182.335 153.175 183.094 153.408H183.096C183.781 153.614 184.54 153.871 185.336 154.172C185.339 154.172 185.341 154.172 185.343 154.174C186.697 154.695 188.157 155.361 189.529 156.196C189.55 156.208 189.57 156.217 189.591 156.229C191.836 157.622 193.863 159.468 194.786 161.907C195.579 163.978 197.435 175.109 199.68 189.895C199.742 190.316 199.804 190.742 199.872 191.17C201.059 199.02 202.34 207.829 203.629 216.825C204.994 226.358 206.357 236.092 207.611 245.114C208.685 252.851 209.678 260.059 210.511 266.158Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.095 266.158H167.115C166.444 263.273 165.817 260.49 165.259 257.877C163.723 250.681 162.712 244.783 162.767 241.616C162.793 240.13 163.355 238.969 164.318 238.076C164.977 237.462 165.826 236.977 166.823 236.597C169.774 235.477 174.015 235.292 178.453 235.577C179.961 235.672 181.491 235.817 182.999 236C191.313 237.009 199.032 239.066 199.032 239.066C199.032 239.066 199.548 241.153 200.159 244.802C200.617 247.539 201.128 251.158 201.508 255.432C201.727 257.914 201.905 260.619 202.005 263.502C202.03 264.367 202.061 265.256 202.095 266.158Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.94 241.659L185.591 244.186L183.897 256.456L183.608 258.55L182.557 266.158H146.106C145.823 261.13 145.562 256.232 145.511 251.96C145.506 251.486 145.504 251.023 145.504 250.567C145.504 244.135 146.068 239.366 147.913 238.163C150.002 236.798 156.934 237.173 164.315 238.077C165.051 238.165 165.791 238.263 166.534 238.362C170.836 238.94 175.142 239.655 178.603 240.271C180.399 240.59 181.967 240.884 183.189 241.118C184.91 241.446 185.94 241.659 185.94 241.659Z",
    fill: "#C65447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.504 158.929C145.504 158.929 165.53 145.979 179.896 152.603C182.185 153.658 184.797 156.604 186.667 158.663C191.859 164.385 202.005 255.269 202.005 255.269C202.005 255.269 173.205 265.024 145.506 251.958V158.929H145.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.035 152.272C181.035 152.272 201.308 160.581 204.055 166.965C206.801 173.349 215.726 212.554 215.726 217.151C215.726 221.749 200.186 218.179 197.685 210.765C195.607 204.608 188.601 185.693 184.906 173.73L181.035 152.272Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.824 158.605C172.398 159.473 165.896 158.547 161.136 155.41C163.286 150.278 164.167 146.224 164.48 143.6C164.498 143.461 164.512 143.325 164.526 143.195C164.667 141.835 164.646 140.914 164.582 140.49H176.023C176.023 140.49 179.152 141.92 179.152 142.908C179.152 143.436 179.156 143.942 179.165 144.426C179.189 145.743 179.242 146.89 179.309 147.878C179.526 151.09 179.894 152.601 179.894 152.601C179.894 152.601 181.294 157.728 176.824 158.605Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.309 147.878C170.639 149.554 165.607 144.817 164.48 143.6C164.32 143.427 164.237 143.322 164.237 143.322C164.329 143.276 164.424 143.235 164.526 143.195C167.754 141.888 175.077 142.927 179.166 144.426C179.189 145.743 179.24 146.893 179.309 147.878Z",
    fill: "#E2915A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.648 138.609C163.196 146.946 173.955 146.673 178.603 146.147C179.911 146.002 180.734 145.835 180.734 145.835C182.211 145.442 183.032 143.116 183.416 140.074C184.175 134.051 183.217 125.207 182.199 122.947C180.667 119.543 177.782 115.864 166.949 118.518C156.113 121.179 159.66 127.929 161.648 138.609Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.601 118.298C181.121 116.248 177.981 113.742 175.13 112.201C169.003 108.888 161.164 112.306 161.132 112.319C152.284 116.209 149.972 122.979 154.662 133.526C159.623 144.678 164.348 143.422 164.348 143.422C164.348 143.422 163.346 142.797 163.436 139.322C163.441 139.125 163.45 138.958 163.459 138.817C163.506 138.105 163.253 137.39 162.721 136.915C161.622 135.934 161.085 132.968 162.006 132.142C163.117 131.145 164.676 132.355 165.176 133.287C165.611 133.944 166.391 134.176 167.117 133.715C169.871 131.975 168.082 128.491 170.713 126.362C173.344 124.231 178.684 126.02 182.634 124.324C187.801 122.398 183.719 119.842 182.601 118.298Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.024 266.158H140.418C140.73 257.116 141.131 246.32 141.552 235.389C141.658 232.555 141.772 229.709 141.883 226.886C141.934 225.69 141.977 224.5 142.024 223.311C142.986 199.037 143.944 177.116 144.146 175.933C144.604 173.263 145.036 170.987 145.504 169.013C146.874 163.263 148.576 160.109 152.288 157.398C152.649 157.122 155.62 155.627 158.234 154.322C160.372 153.263 162.272 152.335 162.33 152.309V152.307H162.332C162.765 152.518 163.241 153.119 163.744 154.012C164.246 154.906 164.775 156.095 165.317 157.483C167.309 162.604 169.463 170.438 170.958 176.29C170.96 176.297 170.963 176.304 170.963 176.308C170.965 176.313 170.965 176.315 170.965 176.32C170.965 176.322 170.965 176.322 170.965 176.322C171.927 180.101 172.619 183.042 172.816 183.888C173.152 185.314 173.591 188.069 174.112 191.804V191.813C174.815 196.906 175.657 203.817 176.548 211.661V211.663C176.641 212.471 176.731 213.285 176.824 214.107C176.928 215.046 177.036 215.997 177.143 216.957V216.96C177.178 217.267 177.21 217.578 177.242 217.888V217.89C177.585 220.995 177.932 224.197 178.274 227.458C178.274 227.46 178.274 227.464 178.277 227.467C178.57 230.153 182.645 232.099 182.927 234.836C182.948 235.035 182.969 235.438 182.994 235.998C183.048 237.155 183.11 238.992 183.187 241.116C183.219 242.06 183.251 243.064 183.288 244.087C183.448 248.638 183.645 253.624 183.867 256.024C183.878 256.137 183.888 256.281 183.895 256.457C183.92 256.935 183.941 257.641 183.959 258.525C183.999 260.406 184.017 263.095 184.024 266.158Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.278 185.721C154.264 185.776 153.584 210.268 172.006 213.241C190.429 216.217 178.189 217.003 178.189 217.003C178.189 217.003 143.526 215.53 142.954 214.616C142.38 213.699 154.278 185.721 154.278 185.721Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.843 223.755C169.843 223.755 169.498 224.001 168.834 224.429C168.823 224.433 168.811 224.442 168.799 224.449C165.988 226.243 157.647 231.134 145.502 234.413C144.227 234.757 142.908 235.086 141.552 235.387C141.658 232.555 141.772 229.709 141.881 226.886C140.277 226.761 138.741 226.557 137.315 226.254C137.364 225.882 137.415 225.509 137.461 225.134C139.007 224.5 140.541 223.889 142.022 223.311C143.227 222.839 144.396 222.39 145.499 221.974C150.488 220.079 154.185 218.794 154.185 218.794L168.952 223.473L169.843 223.755Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.751 223.346C173.751 223.346 171.854 223.82 168.834 224.428C168.823 224.428 168.813 224.431 168.802 224.435C163.232 225.555 153.866 227.124 145.502 227.038C144.268 227.025 143.056 226.976 141.88 226.886C140.277 226.761 138.741 226.557 137.315 226.254C134.259 225.609 131.697 224.516 130.022 222.809C117.578 210.136 136.813 164.649 140.855 160.222C145.576 155.056 154.192 153.242 158.952 152.619C159.151 152.594 159.341 152.568 159.526 152.545C161.199 152.346 162.272 152.305 162.332 152.302C162.335 152.302 162.335 152.302 162.335 152.302C162.335 152.302 161.962 153.501 161.337 155.537C161.094 156.324 160.812 157.238 160.504 158.256C157.582 167.826 151.943 186.635 149.458 197.243C148.547 201.126 148.061 203.907 148.283 204.738C149.252 208.361 159.306 210.224 165.676 211.048C168.332 211.39 170.35 211.554 170.801 211.587C170.833 211.587 170.863 211.589 170.896 211.594L171.264 213.105L172.145 216.728L173.013 220.287L173.751 223.346Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.456 245.151L165.722 243.349L174.392 190.094L217.126 191.894L208.456 245.151Z",
    fill: "#F99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.891 211.599C170.891 211.599 179.209 211.018 179.626 212.957C180.598 217.476 172.474 221.187 169.843 220.935C167.212 220.68 168.978 211.295 170.891 211.599Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.789 202.709C214.789 202.709 206.829 200.221 205.976 202.01C203.983 206.182 211.029 211.672 213.648 212.033C216.267 212.396 216.721 202.859 214.789 202.709Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.198 149.632C163.198 149.632 159.699 151.3 157.943 153.818C157.943 153.818 171.025 176.53 170.965 176.317C170.907 176.104 166.543 152.54 163.198 149.632Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.489 149.951C180.642 150.386 182.851 152.649 183.349 153.901L184.904 173.728C184.904 173.728 181.583 159.176 179.894 152.598C179.466 150.93 179.545 150.421 179.489 149.951Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.557 190.691C188.557 190.691 188.895 189.212 190.841 189.386C192.787 189.557 203.715 190.094 203.715 190.094C203.715 190.094 205.823 190.059 205.626 191.41L188.557 190.691Z",
    fill: "#C65447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.023 140.49C176.023 140.49 177.441 141.784 179.73 141.383C181.088 141.145 181.847 139.382 181.847 139.382C181.847 139.382 179.239 138.912 176.023 140.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.512 157.064L346.947 157.18L336.711 117.993L368.276 117.875L378.512 157.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.448 123.026L347.213 123.074L347.061 122.493L360.296 122.445L360.448 123.026Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.561 124.636L345.943 124.696L345.792 124.118L362.41 124.055L362.561 124.636Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.13 132.612L345.545 132.69L345.395 132.112L366.978 132.031L367.13 132.612Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.63 134.523L346.045 134.601L345.895 134.021L367.478 133.942L367.63 134.523Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.128 136.431L346.544 136.512L346.392 135.932L367.977 135.853L368.128 136.431Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.628 138.343L347.044 138.424L346.892 137.843L368.475 137.764L368.628 138.343Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.128 140.254L347.542 140.333L347.392 139.754L368.975 139.673L369.128 140.254Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.34 144.903L348.756 144.984L348.606 144.403L370.189 144.324L370.34 144.903Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.839 146.814L349.256 146.895L349.104 146.314L370.689 146.235L370.839 146.814Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.339 148.725L349.756 148.804L349.603 148.226L371.186 148.145L371.339 148.725Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.839 150.636L350.253 150.715L350.103 150.137L371.686 150.056L371.839 150.636Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.336 152.548L350.753 152.626L350.603 152.045L372.186 151.967L372.336 152.548Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.231 205.759L359.666 205.877L349.43 166.687L380.995 166.572L391.231 205.759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.167 171.72L359.932 171.769L359.779 171.19L373.017 171.142L373.167 171.72Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.279 173.33L358.664 173.393L358.511 172.812L375.129 172.752L375.279 173.33Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.849 181.306L358.266 181.387L358.113 180.806L379.699 180.728L379.849 181.306Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.349 183.217L358.764 183.296L358.613 182.718L380.197 182.637L380.349 183.217Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.846 185.129L359.263 185.207L359.113 184.629L380.696 184.548L380.846 185.129Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.346 187.04L359.763 187.118L359.61 186.538L381.196 186.459L381.346 187.04Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.846 188.949L360.261 189.03L360.11 188.449L381.694 188.37L381.846 188.949Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.061 193.599L361.475 193.678L361.325 193.1L382.908 193.019L383.061 193.599Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.558 195.51L361.975 195.589L361.825 195.011L383.408 194.93L383.558 195.51Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.058 197.422L362.474 197.5L362.322 196.919L383.907 196.841L384.058 197.422Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.558 199.33L362.972 199.411L362.822 198.831L384.405 198.752L384.558 199.33Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.055 201.242L363.472 201.323L363.322 200.742L384.905 200.663L385.055 201.242Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.038 254.781L372.471 254.899L362.234 215.71L393.802 215.594L404.038 254.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.972 220.743L372.737 220.791L372.584 220.213L385.821 220.164L385.972 220.743Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.084 222.353L371.469 222.415L371.316 221.835L387.934 221.774L388.084 222.353Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.654 230.328L371.071 230.409L370.918 229.829L392.504 229.75L392.654 230.328Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.154 232.24L371.568 232.319L371.418 231.74L393.001 231.659L393.154 232.24Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.653 234.151L372.068 234.23L371.917 233.651L393.501 233.57L393.653 234.151Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.151 236.062L372.568 236.141L372.415 235.56L394.001 235.481L394.151 236.062Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.651 237.971L373.067 238.052L372.915 237.471L394.498 237.393L394.651 237.971Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.865 242.622L374.282 242.7L374.129 242.122L395.713 242.041L395.865 242.622Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.365 244.533L374.78 244.612L374.629 244.033L396.213 243.952L396.365 244.533Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.862 246.444L375.279 246.523L375.126 245.942L396.712 245.863L396.862 246.444Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.362 248.353L375.779 248.434L375.626 247.853L397.21 247.774L397.362 248.353Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.862 250.264L376.277 250.345L376.126 249.764L397.71 249.686L397.862 250.264Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.533 255.112L252.132 255.519L220.358 133.877L234.739 118.391L326.731 118.051L362.533 255.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.321 138.607L257.412 138.75L256.965 137.047L295.874 136.904L296.321 138.607Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.534 143.343L253.682 143.524L253.238 141.819L302.087 141.638L302.534 143.343Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.963 166.789L252.513 167.023L252.067 165.318L315.519 165.084L315.963 166.789Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.432 172.405L253.98 172.639L253.534 170.936L316.985 170.7L317.432 172.405Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.899 178.023L255.448 178.256L255.001 176.551L318.453 176.317L318.899 178.023Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.366 183.639L256.914 183.875L256.47 182.169L319.92 181.936L320.366 183.639Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.833 189.257L258.381 189.49L257.937 187.787L321.386 187.551L321.833 189.257Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.403 202.926L261.952 203.16L261.507 201.455L324.959 201.221L325.403 202.926Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.87 208.542L263.418 208.776L262.974 207.073L326.426 206.837L326.87 208.542Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.337 214.16L264.886 214.394L264.441 212.688L327.893 212.455L328.337 214.16Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.804 219.776L266.352 220.012L265.908 218.306L329.36 218.073L329.804 219.776Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.271 225.394L267.822 225.627L267.375 223.922L330.827 223.688L331.271 225.394Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.358 133.877L238.767 133.808L234.739 118.391L220.358 133.877Z",
    fill: "#ADCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.245 350.513H343.368V318.77H433.532C440.543 318.77 446.226 324.452 446.226 331.463V337.535C446.226 344.703 440.414 350.513 433.245 350.513Z",
    fill: "#FCECDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.938 331.831V336.607C522.938 339.159 522.251 341.549 521.052 343.601C518.644 347.734 514.162 350.513 509.03 350.513H340.612C339.497 350.513 338.594 349.61 338.594 348.497V347.782C338.594 346.67 339.497 345.767 340.612 345.767H443.278C443.826 345.098 444.31 344.374 444.72 343.601C445.682 341.79 446.224 339.726 446.224 337.532V331.461C446.224 330.343 446.08 329.26 445.807 328.231C445.347 326.484 444.525 324.883 443.426 323.517H340.612C339.497 323.517 338.594 322.615 338.594 321.5V320.787C338.594 319.672 339.497 318.77 340.612 318.77H509.877C515.842 318.77 520.872 322.768 522.434 328.231C522.765 329.376 522.938 330.584 522.938 331.831Z",
    fill: "#699DEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.436 328.231H445.81C445.349 326.484 444.528 324.883 443.429 323.517H340.614C339.499 323.517 338.597 322.615 338.597 321.5V320.787C338.597 319.672 339.499 318.77 340.614 318.77H509.879C515.844 318.77 520.874 322.768 522.436 328.231Z",
    fill: "#548EE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.368 334.642L355.839 335.174L343.368 335.496V334.642Z",
    fill: "#F4D2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.368 339.622L373.035 340.156L343.368 340.478V339.622Z",
    fill: "#F4D2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.803 375.138H460.479V350.448H364.025C357.422 350.448 352.067 355.802 352.067 362.406C352.07 369.437 357.769 375.138 364.803 375.138Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.986 375.138H563.874V350.448H454.708C447.993 350.448 442.551 355.89 442.551 362.605V362.704C442.554 369.571 448.121 375.138 454.986 375.138Z",
    fill: "#FCECDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.284 375.138H567.657C568.678 375.138 569.504 374.312 569.504 373.292C569.504 372.271 568.678 371.445 567.657 371.445H435.284C434.264 371.445 433.438 372.271 433.438 373.292C433.438 374.31 434.264 375.138 435.284 375.138Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.284 354.138H567.657C568.678 354.138 569.504 353.312 569.504 352.292C569.504 351.271 568.678 350.445 567.657 350.445H435.284C434.264 350.445 433.438 351.271 433.438 352.292C433.438 353.312 434.264 354.138 435.284 354.138Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.876 362.792L549.167 363.206L563.876 363.458V362.792Z",
    fill: "#F4D2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.876 357.109L528.882 357.525L563.876 357.775V357.109Z",
    fill: "#F4D2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.243 357.442C529.243 357.442 530.743 358.502 531.24 360.247C531.328 360.552 531.383 360.878 531.395 361.223C531.478 363.539 531.395 368.782 531.395 368.782L535.824 366.161L540.238 368.782V361.677C540.238 360.332 539.859 359.025 539.156 358.169C538.815 357.755 538.401 357.442 537.932 357.442H529.243V357.442Z",
    fill: "#699DEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.243 357.442C529.243 357.442 530.743 358.502 531.24 360.247L540.113 360.351C540.113 360.351 539.766 357.854 537.934 357.442H529.243Z",
    fill: "#568CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.852 318.837H541.606V282.561H443.53C435.703 282.561 429.356 288.907 429.356 296.735V304.34C429.356 312.346 435.846 318.837 443.852 318.837Z",
    fill: "#FCECDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.656 296.636V304.442C431.679 307.777 433.525 310.669 436.237 312.217C437.572 312.976 439.116 313.411 440.756 313.411H546.914C548.159 313.411 549.168 314.42 549.168 315.664V316.585C549.168 317.83 548.159 318.839 546.914 318.839H363.523C358.262 318.839 353.611 316.224 350.802 312.219C349.032 309.697 347.991 306.624 347.991 303.306V297.147C347.991 294.875 348.511 292.723 349.439 290.805C351.797 285.927 356.792 282.563 362.575 282.563H546.914C548.159 282.563 549.168 283.57 549.168 284.814V285.735C549.168 286.98 548.159 287.989 546.914 287.989H440.43C437.885 287.989 435.582 289.072 433.972 290.805C432.549 292.339 431.67 294.382 431.656 296.636Z",
    fill: "#B5453C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.606 300.699L527.996 301.31L541.606 301.675V300.699Z",
    fill: "#F4D2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.606 292.351L509.229 292.961L541.606 293.327V292.351Z",
    fill: "#F4D2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.562 292.838C509.562 292.838 511.698 293.988 512.406 295.879C512.531 296.21 512.612 296.564 512.628 296.936C512.746 299.449 512.628 305.134 512.628 305.134L518.935 302.29L525.227 305.134V297.429C525.227 295.971 524.687 294.555 523.683 293.627C523.197 293.179 522.607 292.838 521.941 292.838H509.562Z",
    fill: "#F99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.562 292.838C509.562 292.838 511.698 293.988 512.406 295.879L525.048 295.992C525.048 295.992 524.553 293.285 521.943 292.838H509.562Z",
    fill: "#ED7D2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.041 269.11C424.636 278.849 431.674 282.607 431.674 282.607H460.953C460.951 282.607 414.772 261.681 419.041 269.11Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.527 344.457C442.29 345.332 442.388 346.308 442.01 347.352C442.01 347.356 442.008 347.363 442.003 347.366C441.305 349.295 438.998 351.45 436.318 353.601C435.976 353.877 435.671 354.129 435.407 354.363C435.337 354.423 435.268 354.485 435.203 354.545C435.15 354.592 435.097 354.643 435.046 354.687C432.547 356.991 433.486 357.519 428.998 362.193C423.879 367.519 420.353 367.614 419.351 367.13C418.502 366.716 420.226 363.891 422.135 360.716C422.227 360.564 422.318 360.409 422.412 360.254C422.667 359.832 422.919 359.402 423.171 358.979C425.409 355.156 424.835 353.365 424.303 347.678C423.872 343.057 417.114 321.86 417.114 321.86L426.924 320.171C426.924 320.171 429.879 337.051 433.135 339.649C434.875 341.035 436.823 341.051 438.496 342.079C438.614 342.15 438.729 342.222 438.843 342.298C439.794 342.93 440.761 343.58 441.527 344.457Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.527 344.457C442.29 345.331 442.388 346.308 442.01 347.351C442.01 347.356 442.008 347.363 442.004 347.365C441.147 349.293 438.898 351.437 436.309 353.582C435.971 353.862 435.673 354.122 435.407 354.362C435.337 354.422 435.268 354.485 435.203 354.545C435.15 354.591 435.097 354.642 435.046 354.686C432.547 356.991 433.486 357.518 428.998 362.192C423.879 367.518 420.353 367.613 419.351 367.13C418.502 366.716 420.226 363.89 422.135 360.716C423.132 360.35 427.76 358.471 431.26 353.992C434.342 350.058 436.399 345.005 438.498 342.078C438.616 342.15 438.732 342.222 438.845 342.298C439.794 342.93 440.761 343.58 441.527 344.457Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.424 338.33C361.818 341.359 357.503 340.852 352.681 339.675C347.859 338.497 349.004 339.897 342.141 339.138C335.279 338.379 333.199 335.82 332.99 334.799C332.803 333.895 336.195 333.575 339.832 333.157C340.29 333.106 340.749 333.048 341.209 332.992C345.316 332.476 348.324 329.827 352.054 327.65C355.587 325.588 360.86 317.189 360.86 317.189L370.273 317.934C370.273 317.934 365.333 325.435 363.424 328.698C362.299 330.616 362.36 333.152 362.501 335.112C362.57 336.176 362.64 337.264 362.424 338.33Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.681 339.674C347.859 338.497 349.004 339.896 342.141 339.137C335.279 338.379 333.199 335.819 332.99 334.799C332.803 333.894 336.195 333.575 339.832 333.156L339.867 333.226C339.867 333.226 343.983 336.143 349.696 336.28C354.351 336.393 359.285 335.058 362.501 335.111C362.575 336.176 362.644 337.266 362.429 338.332C361.818 341.359 357.503 340.854 352.681 339.674Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.495 278.145L407.294 301.823L418.782 332.737C418.782 332.737 421.899 333.038 424.886 332.18C427.635 331.386 430.789 329.306 430.789 329.306C430.789 329.306 427.598 296.112 421.649 277.058C420.124 272.166 418.414 268.21 416.528 265.984C407.303 255.084 398.495 278.145 398.495 278.145Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.442 240.543C413.206 238.683 429.648 241.071 446.164 244.303L449.623 238.6L485.295 235.814C485.295 235.814 497.067 261.918 490.621 278.552C489.675 280.998 487.791 282.565 484.584 282.618C484.584 282.62 484.066 282.615 484.064 282.618C484.064 282.618 462.832 282.606 455.937 282.606C438.197 282.606 418.391 270.412 415.829 269.899C411.637 269.061 409.959 277.446 405.764 286.253C401.572 295.059 366.346 325.252 366.346 325.252C366.346 325.252 360.932 325.305 358.697 324.468C356.293 323.565 355.411 322.395 355.411 322.395C355.411 322.395 394.441 244.738 407.442 240.543Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.829 189.476C462.531 196.47 488.303 210.971 488.437 210.876C488.437 210.876 497.91 214.446 503.282 210.876C512.239 204.927 517.042 188.92 500.663 175.144C492.495 168.274 486.69 166.601 485.808 155.629C485.329 149.678 477.194 130.034 463.677 131.852C462.548 132.005 455.595 132.329 451.025 134.728C439.379 140.844 430.786 186.768 449.829 189.476Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.477 183.522C460.422 183.559 466.727 185.711 470.945 183.844C474.911 182.09 477.916 175.565 477.858 175.56C476.054 175.477 474.073 173.899 472.546 163.547L471.778 163.822L458.857 168.471C458.857 168.471 459.794 172.617 460.398 176.562C460.91 179.878 461.183 183.052 460.477 183.522Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.857 168.471C458.857 168.471 459.794 172.617 460.398 176.562C467.819 175.227 470.732 167.832 471.775 163.82L458.857 168.471Z",
    fill: "#ED975D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.934 172.587C456.934 172.587 474.61 170.215 472.964 159.229C471.317 148.243 472.49 140.54 461.134 141.589C449.778 142.639 448.218 147.158 447.878 150.959C447.533 154.759 452.293 172.92 456.934 172.587Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.519 144.937C448.519 144.937 459.834 154.687 467.532 155.474C475.227 156.261 478.143 153.79 478.143 153.79C478.143 153.79 473.605 150.023 470.875 143.944C470.07 142.153 468.372 140.923 466.414 140.754C460.919 140.279 450.5 140.064 448.519 144.937Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.592 144.065C455.592 144.065 451.807 147.725 450.615 150.439C449.465 153.058 449.121 159.324 450.037 161.814C450.037 161.814 444.139 150.344 447.478 144.773C451.018 138.865 455.592 144.065 455.592 144.065Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.592 209.559C446.127 245.34 445.738 237.864 449.653 241.258C450.597 242.075 453.249 242.563 456.738 242.792C467.71 243.521 486.996 241.714 487.729 239.685C490.26 232.669 488.474 230.49 490.584 219.749C490.804 218.606 491.077 217.371 491.396 216.024C493.157 208.647 494.87 206.137 488.625 194.286C482.96 183.55 477.076 174.836 476.546 175.15C461.604 184.022 460.398 176.564 460.398 176.564C460.398 176.564 445.331 192.106 445.592 209.559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.294 301.823L418.782 332.738C418.782 332.738 421.899 333.039 424.886 332.18C427.635 331.386 430.788 329.306 430.788 329.306C430.788 329.306 427.598 296.112 421.649 277.058L407.294 301.823Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.398 176.564C460.398 176.564 445.023 179.172 443.216 185.792C441.409 192.412 430.784 231.332 430.784 231.332C430.784 231.332 438.6 232.737 442.212 229.125C445.823 225.513 454.776 195.623 454.776 195.623L460.398 176.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.738 242.795C467.71 243.524 486.996 241.717 487.729 239.687C490.26 232.672 488.474 230.492 490.584 219.752L485.293 204.851C485.293 204.851 486.167 221.445 481.273 225.809C476.384 230.173 461.238 234.234 458.857 237.88C457.712 239.63 456.958 241.386 456.738 242.795Z",
    fill: "#EBF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.309 235.816C469.309 235.816 458.484 233.405 456.738 234.368C454.991 235.328 450.722 238.827 450.187 240.044C449.653 241.261 454.074 239.121 455.514 238.734C456.446 238.484 458.899 239.336 460.111 239.741C465.22 241.444 468.351 240.567 468.351 240.567L469.309 235.816Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.558 175.144C476.558 175.144 491.093 176.039 496.123 183.057C503.206 192.934 517.255 235.034 509.203 240.65C500.135 246.974 467.932 242.304 467.932 242.304C467.932 242.304 466.86 237.295 468.351 234.872C469.841 232.45 494.071 228.535 495.191 227.417C496.308 226.3 481.213 205.61 481.213 202.255C481.213 198.899 476.558 175.144 476.558 175.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.212 237.378C456.212 237.378 453.945 240.303 453.202 240.652C452.459 241.002 451.978 240.914 451.978 240.914L453.507 238.163L456.212 237.378Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.738 234.366L450.144 237.568C450.144 237.568 450.424 238.026 451.236 237.989C452.048 237.952 454.096 237.202 454.096 237.202L456.738 234.366Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.202 245.134H401.04L385.35 206.116H437.431L453.202 245.134Z",
    fill: "#F99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.429 243.614H469.309V245.134H401.04L400.429 243.614Z",
    fill: "#ED7D2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.208 225.626C413.814 224.254 414.608 223.144 415.98 223.144C417.352 223.144 418.782 224.256 419.175 225.626C419.569 226.998 418.775 228.109 417.403 228.109C416.031 228.109 414.601 226.996 414.208 225.626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7313 260.459L57.6207 261.229C56.436 262.05 54.8025 261.754 53.9787 260.57L47.5186 251.25C46.6972 250.065 46.9933 248.429 48.178 247.608L49.7699 246.504C50.0013 246.342 50.3206 246.4 50.4826 246.634C50.6445 246.865 50.5867 247.184 50.353 247.346L48.7611 248.45C48.0392 248.95 47.8587 249.945 48.3585 250.667L54.8187 259.987C55.3184 260.708 56.3134 260.889 57.0353 260.389L58.1459 259.619C58.8678 259.119 59.0483 258.124 58.5485 257.402L54.2587 251.215C54.0967 250.984 54.1546 250.664 54.3883 250.502C54.6197 250.34 54.939 250.398 55.1009 250.632L59.3907 256.819C60.2145 258.004 59.9183 259.637 58.7313 260.459Z",
    fill: "#AFCDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8141 269.651L63.8219 271.033C61.9732 272.315 59.3516 271.745 57.9795 269.765L48.2662 255.752C48.1042 255.521 48.162 255.202 48.3957 255.04C48.6271 254.878 48.9464 254.936 49.1084 255.169L58.8218 269.182C59.8722 270.7 61.8552 271.153 63.2388 270.193L65.231 268.812C66.617 267.851 66.8877 265.836 65.8349 264.32L54.7726 248.357C53.7221 246.84 51.7392 246.388 50.3532 247.346C50.1218 247.508 49.8025 247.45 49.6406 247.217C49.4786 246.985 49.5364 246.666 49.7701 246.504C51.6189 245.222 54.2404 245.791 55.6125 247.772L66.6749 263.735C68.0493 265.716 67.6629 268.37 65.8141 269.651Z",
    fill: "#AFCDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1766 342.842L79.4172 344.816C79.6718 346.924 78.1655 348.846 76.0599 349.101L59.4976 351.112C57.3897 351.368 55.467 349.86 55.2124 347.754L54.87 344.927C54.8191 344.513 55.1129 344.138 55.5271 344.089C55.939 344.038 56.3161 344.332 56.3647 344.746L56.7072 347.574C56.8622 348.856 58.033 349.774 59.3148 349.617L75.8771 347.606C77.159 347.451 78.0775 346.28 77.9202 344.999L77.6796 343.025C77.5245 341.743 76.3538 340.824 75.0719 340.982L64.0767 342.317C63.6625 342.368 63.2876 342.072 63.2391 341.66C63.1882 341.246 63.4843 340.871 63.8962 340.822L74.8914 339.487C76.997 339.23 78.9198 340.736 79.1766 342.842Z",
    fill: "#AFCDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.998 339.936L96.4283 343.474C96.8263 346.759 94.2881 349.779 90.7664 350.207L65.8652 353.229C65.451 353.28 65.0762 352.983 65.0276 352.572C64.9767 352.157 65.2728 351.783 65.6847 351.734L90.586 348.712C93.2816 348.386 95.2321 346.116 94.9336 343.656L94.5033 340.119C94.2048 337.657 91.7683 335.921 89.0727 336.25L60.7077 339.693C58.0121 340.019 56.0615 342.289 56.36 344.749C56.4109 345.163 56.1148 345.538 55.7029 345.586C55.2887 345.637 54.9139 345.343 54.8653 344.929C54.4673 341.643 57.0056 338.624 60.5272 338.196L88.8923 334.753C92.4116 334.325 95.6 336.65 95.998 339.936Z",
    fill: "#AFCDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.956 109.008C366.248 107.774 365.484 106.538 364.25 106.246C363.016 105.955 361.78 106.719 361.489 107.953C361.198 109.186 361.962 110.423 363.195 110.714C364.429 111.005 365.665 110.241 365.956 109.008Z",
    fill: "#F99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.314 376.744H4.22086C3.84362 376.744 3.53516 376.574 3.53516 376.366V376.238C3.53516 376.03 3.84362 375.86 4.22086 375.86H607.314C607.692 375.86 608 376.03 608 376.238V376.366C608 376.574 607.692 376.744 607.314 376.744Z",
    fill: "#2E3552"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 590,
    height: 400,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.588ca306bc69c3920b8e73238c4c3459.svg";
export { ForwardRef as ReactComponent };